import { render, staticRenderFns } from "./BaseCell.vue?vue&type=template&id=31c48693&scoped=true&"
import script from "./BaseCell.vue?vue&type=script&lang=js&"
export * from "./BaseCell.vue?vue&type=script&lang=js&"
import style0 from "./BaseCell.vue?vue&type=style&index=0&id=31c48693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c48693",
  null
  
)

export default component.exports